<template>
    <div>
        <div class="row">
            <div class="col-md-12">
              {{ translate[lang]["water_cityheat_info"] }}

              <div v-if="!cityheatInfo.supplier.id">
                <i>{{ translate[lang]["enter_zipcode"] }}</i>
              </div>

              <div v-else>
                {{ translate[lang]["we_register_you_with"] }} <strong>{{ cityheatInfo.supplier.title }}</strong>.

                <div class="row mt-3">
                  <div v-if="cityheatInfo.logo" class="col-md-4">
                    <img style="max-width: 225px; max-height: 150px;" :src="'https://crm.propropertypartners.com' + cityheatInfo.logo" />
                  </div>
                  <div class="col-md-8">
                    {{ translate[lang]["usage_avg_info"] }} {{ cityheatInfo.usage }}GJ, {{ translate[lang]["avg_cost_info"] }}:<br />
                    <strong>{{ translate[lang]["permonth"] }}</strong>: €{{ formatPrice(cityheatInfo.total) }}<br />
                    <strong>{{ translate[lang]["yearly"] }}</strong>: €{{ formatPrice(cityheatInfo.yearly) }}
                  </div>
                </div>

              </div>

            </div>
        </div>
    </div>
</template>

<script>

import { mapState} from "vuex";

    export default {
        name: "Cityheat",
        data() {
            return {

            };
        },
        computed: {
          ...mapState({
            overview: (state) => state.forms.overview
          }),
          cityheatInfo() {
            return this.overview.filter((o) => o.id === 7)[0];
          }
        },
        methods: {

          formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }

        },
        mounted() {

        }
    };
</script>
